import { Box, CardProps, Heading, IconButton, Tag } from "@chakra-ui/react";
import { Account, RoleType } from "common";
import { useNavigate } from "react-router-dom";
import { Avatar } from "../avatar/Avatar";
import { CiEdit } from "react-icons/ci";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { Card } from "../utils/Card";

const ROLE_TYPE_COLOR: { [roleType in RoleType]: string } = {
  [RoleType.Admin]: "blue",
  [RoleType.Developer]: "green",
};

interface AccountCardProps extends CardProps {
  account: Account;
  includeEmail?: boolean;
  clickable?: boolean;
  canEditAvatar?: boolean;
  size?: string;
}

export const AccountCard = ({
  account,
  includeEmail,
  clickable = true,
  canEditAvatar,
  size = "200",
  ...cardProps
}: AccountCardProps) => {
  const navigate = useNavigate();
  return (
    <Card
      display={"flex"}
      alignItems={"center"}
      paddingLeft={2}
      marginBottom={4}
      width={"100%"}
      cursor={clickable ? "pointer" : undefined}
      onClick={
        clickable
          ? () => {
              navigate(`/account/${account.id}`);
            }
          : undefined
      }
      {...cardProps}
    >
      <Box display={"flex"} justifyContent={"center"} position={"relative"}>
        <Avatar
          config={account.avatarConfig}
          round={true}
          width={size}
          height={size}
        />
        {canEditAvatar ? (
          <IconButton
            icon={<CiEdit />}
            aria-label="edit avatar"
            position={"absolute"}
            bottom={0}
            right={0}
            borderRadius={"full"}
            colorScheme={THEME_COLOR_SCHEME}
            onClick={() => navigate("/avatar")}
          />
        ) : null}
      </Box>
      <Box display={"flex"} width={"100%"} flexDir={"column"} padding={4}>
        <Heading fontSize={"large"}>
          {account.fName} {account.lName}
        </Heading>
        {includeEmail ? (
          <Heading fontSize={"medium"} color={"gray.600"}>
            {account.email}
          </Heading>
        ) : null}
        <Box display={"flex"} marginTop={2}>
          {account.roles.map((role) => (
            <Tag
              key={role.id}
              variant={"outline"}
              borderRadius={"full"}
              colorScheme={ROLE_TYPE_COLOR[role.type]}
              marginRight={1}
            >
              {role.type}
            </Tag>
          ))}
        </Box>
      </Box>
    </Card>
  );
};
